import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadVacancies } from 'redux/Vacancies/actions';
import { ssrHandler } from 'utils';

import CareerTemplate from './CareerTemplate';
import SidePanel from '../widgets/SidePanel';

class Career extends PureComponent {
  state = {
    open: false,
    selected: null
  };

  togglePanel = (cardId) => {
    this.setState({
      selected: cardId,
      open: !this.state.open
    });
  };

  render() {
    const data = (this.props.vacancies.results || [])
      .find(({ id }) => id === this.state.selected);

    return (
      <div>
        <CareerTemplate
          vacancies={this.props.vacancies}
          isMobile={this.props.isMobile}
          onCardClick={this.togglePanel}
        />

        <SidePanel
          open={this.state.open}
          content={data && data.content}
          onCloseClick={this.togglePanel}
        />
      </div>
    );
  }
}

Career.propTypes = {
  vacancies: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  isMobile: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  vacancies: state.vacancies,
  isMobile: state.app.width < 580
});

function loadVacanciesData(store, nextState, replace, callback) {
  const actions = [loadVacancies()];

  ssrHandler(store.dispatch, actions, callback);
}

export default (store) => ({
  path: '/we/career/',
  component: connect(mapStateToProps)(Career),
  onEnter: loadVacanciesData.bind(null, store)
});



// WEBPACK FOOTER //
// ./src/components/Career/index.js